module.exports = __webpack_public_path__ + "assets/img/ENS.d86516e3.png";